import { render, staticRenderFns } from "./home-files.vue?vue&type=template&id=466134d8&scoped=true"
import script from "./home-files.vue?vue&type=script&lang=js"
export * from "./home-files.vue?vue&type=script&lang=js"
import style0 from "./home-files.vue?vue&type=style&index=0&id=466134d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466134d8",
  null
  
)

export default component.exports